import { ActionMenu } from '@side/pantry';

interface Props {
  canEdit: boolean;
  onEdit: () => void;
  onRemove: () => void;
}

export function ContactActionsMenu({ canEdit, onEdit, onRemove }: Props) {
  const menuOptions = [
    {
      label: 'Edit Contact',
      onClick: onEdit,
      disabled: !canEdit,
      tooltip: canEdit ? undefined : 'Side App contacts cannot be edited',
    },
    {
      label: 'Remove',
      onClick: onRemove,
      labelColor: 'error',
    },
  ];

  return (
    <ActionMenu
      title="Contact Actions"
      options={menuOptions}
      sx={{ alignSelf: 'stretch' }}
    />
  );
}
